import { render, staticRenderFns } from "./XConfirmDialog.vue?vue&type=template&id=44d91f9c"
import script from "./XConfirmDialog.vue?vue&type=script&lang=js"
export * from "./XConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports